'use strict';

var React = require('react');

const WithinFilterContext = /*#__PURE__*/React.createContext(false);

exports.WithinFilterContext = WithinFilterContext;
